/* eslint-disable no-mixed-operators */
import React, { useEffect, useState } from "react";

// routing
import { Link, useHistory } from "react-router-dom";

// react dropzone
import ReactDropzone from "react-dropzone";

// action
import { getCategory } from "../../../store/giftCategory/action";
import { createNewGift } from "../../../store/gift/action";

import SVGA from "svgaplayerweb";

// redux
import { connect, useSelector } from "react-redux";

import { permissionError } from "../../../util/Alert";

import { Switch } from "@material-ui/core";

const GiftPage = (props) => {
  const history = useHistory();

  const categoryDetail = JSON.parse(localStorage.getItem("Category"));
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [coin, setCoin] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");

  const [previewImagePath, setPreviewImagePath] = useState("");
  const [previewImageData, setPreviewImageData] = useState("");
  const [imageData, setImageData] = useState("");
  const [imagePath, setImagePath] = useState("");

  const [isSvga, setIsSvga] = useState();
  const [showInStore, setShowInStore] = useState(true);

  const GiftClick = localStorage.getItem("GiftClick");

  const [errors, setError] = useState("");

  useEffect(() => {
    if (GiftClick !== null) {
      props.getCategory();
    } // eslint-disable-next-line
  }, []);

  const categories = useSelector((state) => state.giftCategory.giftCategory);

  useEffect(() => {
    setError({
      image: "",
      coin: "",
      category: "",
    });
    setCategory("");
    setCoin("");
    // setImages([]);
  }, []);

  useEffect(() => {
    if (isSvga) {
      const svgaElement = document.getElementById("svgaAdd");
      if (svgaElement) {
        // Error handling
        try {
          var player = new SVGA.Player(`div[attr="addInputImage"]`);
          var parser = new SVGA.Parser(`div[attr="addInputImage}"]`);
          parser.load(imagePath, function (videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          });
        } catch (error) {
          console.error("Error initializing SVGA Player:", error);
        }
      } else {
        console.error("SVGA element not found in the DOM");
      }
    }
  }, [isSvga])

  useEffect(() => {
    if (imagePath) {
      console.log("image path: ", imageData);
      var fileNameParts = imageData.name.split('.');
      const fileExtension = fileNameParts[fileNameParts.length - 1];
      console.log("file type: ", fileExtension)
      setIsSvga(fileExtension === "svga");
    }
  }, [imagePath]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !coin ||
      (GiftClick !== null && (category === "Select Category" || !category))
      || !name || !imagePath || !previewImagePath
    ) {
      const errors = {};

      if (!coin) errors.coin = "Diamond is Required!";

      if (coin < 0) errors.coin = "Invalid Diamond ";

      if (!name) errors.name = "Name is Required";

      if (!imagePath) errors.imagePath = "Image is Required";

      if (!previewImagePath) errors.previewImagePath = "Preview image is Required";

      // TODO: Image validation
      if (GiftClick !== null && (category === "Select Category" || !category)) {
        errors.category = "Please select a Category!";
      }
      return setError({ ...errors });
    }

    const coinValid = isNumeric(coin);
    if (!coinValid) {
      return setError({ ...errors, coin: "Invalid Diamond!!" });
    }
    const formData = new FormData();

    formData.append("category", category ? category : categoryDetail._id);
    formData.append("coin", coin);
    formData.append("type", isSvga ? 2 : 1);
    formData.append("imageVideo", imageData);
    formData.append("previewImage", previewImageData)
    formData.append("name", name);
    formData.append("showInStore", showInStore);

    if (!hasPermission) return permissionError();
    props.createNewGift(formData);

    setTimeout(() => {
      GiftClick === null && history.push("/admin/giftCategory/gift");
    }, 3000);
  };

  const isNumeric = (value) => {
    const val = value === "" ? 0 : value;
    const validNumber = /^\d+$/.test(val);
    return validNumber;
  };

  // for  image
  const handleInputAddImage = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };


  // for preview image
  const handleInputAddImagePreview = (e) => {
    if (e.target.files[0]) {
      setPreviewImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setPreviewImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Gift Dialog</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/admin/giftCategory/gift" className="text-danger">
                    Gift
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Dialog
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body card-overflow">
              <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>

              <form>
                <div className="row">
                  <div className="col-md-6">

                    <div className="form-group">
                      <label className="text-gray mb-2">Name</label>

                      <input
                        type="text"
                        className="form-control"
                        required=""
                        placeholder="Name"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              name: "Name is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              name: "",
                            });
                          }
                        }}
                      />

                      {errors.name && (
                        <div className="ml-2 mt-1">
                          {errors.name && (
                            <div className="pl-1 text__left">
                              <span className="text-red">{errors.name}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">Diamond</label>
                      <input
                        type="number"
                        className="form-control"
                        required=""
                        placeholder="20"
                        value={coin}
                        onChange={(e) => {
                          setCoin(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              coin: "Diamond is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              coin: "",
                            });
                          }
                        }}
                      />
                      {errors.coin && (
                        <div className="ml-2 mt-1">
                          {errors.coin && (
                            <div className="pl-1 text__left">
                              <span className="text-red">{errors.coin}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="form-group mt-4">
                  <label className="text-gray mb-2">Show in store</label>

                  <Switch
                    checked={showInStore}
                    onChange={(event) => setShowInStore(event.target.checked)}
                    name="checkedA"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />

                </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">Category</label>
                      {GiftClick === null ? (
                        <input
                          type="text"
                          className="form-control"
                          required=""
                          placeholder="Category Name"
                          disabled
                          value={categoryDetail.name}
                        />
                      ) : (
                        <>
                          <select
                            className="form-select form-control"
                            aria-label="Default select example"
                            value={category}
                            onChange={(e) => {
                              setCategory(e.target.value);
                              if (e.target.value === "Select Category") {
                                return setError({
                                  ...errors,
                                  category: "Please select a Category!",
                                });
                              } else {
                                return setError({
                                  ...errors,
                                  category: "",
                                });
                              }
                            }}
                          >
                            <option value="Select Category" selected>
                              Select Category
                            </option>
                            {categories.map((category) => {
                              return (
                                <option value={category._id}>
                                  {category.name}
                                </option>
                              );
                            })}
                          </select>
                          {errors.category && (
                            <div className="ml-2 mt-1">
                              {errors.category && (
                                <div className="pl-1 text__left">
                                  <span className="text-red">
                                    {errors.category}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <>
                  <div className="form-group mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label className="mb-2 text-gray">Select Image</label>
                    <input
                      type="file"
                      accept=".svga, .gif"
                      className="form-control form-control-sm"
                      required=""
                      onChange={handleInputAddImage}
                    />
                    {errors.imagePath && (
                      <div className="ml-2 mt-1">
                        {errors.imagePath && (
                          <div className="pl-1 text__left">
                            <span className="text-red">{errors.imagePath}</span>
                          </div>
                        )}
                      </div>
                    )}
                    {imagePath && isSvga && (
                      <>
                        <div
                          id="svgaAdd"
                          attr="addInputImage"
                          style={{
                            boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                            marginTop: 10,
                            float: "left",
                            objectFit: "contain",
                            marginRight: 15,
                            height: "100px",
                            width: "100px",
                          }}
                        ></div>
                      </>
                    )}
                    {imagePath && !isSvga && (
                      <>
                        <img
                          src={imagePath}
                          className="mt-3 rounded float-left mb-2"
                          height="100px"
                          width="100px"
                        />
                      </>
                    )}
                  </div>

                  {/* preview image */}
                  <div className="form-group mt-4">
                    <label className="mb-2 text-gray">Select Preview Image</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control form-control-sm"
                      required=""
                      onChange={handleInputAddImagePreview}
                    />

                    {errors.previewImagePath && (
                      <div className="ml-2 mt-1">
                        {errors.previewImagePath && (
                          <div className="pl-1 text__left">
                            <span className="text-red">{errors.previewImagePath}</span>
                          </div>
                        )}
                      </div>
                    )}
                    {previewImagePath && (
                      <>
                        <img
                          src={previewImagePath}
                          className="mt-3 rounded float-left mb-2"
                          height="100px"
                          width="100px"
                        />
                      </>
                    )}
                  </div>
                </>

                <div className="mt-5">
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={() => {
                      GiftClick === null
                        ? history.push("/admin/giftCategory/gift")
                        : history.push("/admin/gift");
                    }}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { createNewGift, getCategory })(GiftPage);
